import web_socket from './web_socket'
//导出
const url = (document.location.protocol == 'http:' ? 'ws://' : 'wss://') + document.location.host + '/ws'

import global from '@/utils/global.js'

export default new web_socket(url, global.token)